


    import React from 'react';
    import ReactDOM from 'react-dom';
    import { withStyles } from '@wix/native-components-infra';
    import EditorAppWrapper from '@wix/yoshi-flow-editor/runtime/esm/EditorAppWrapper.js';
    import Widget from '/home/builduser/agent00/work/d3ce2d6334d0e6ab/client/wixstores-client/wixstores-client-gallery/src/components/GridGallery/Widget/index.tsx';
    import createController from '/home/builduser/agent00/work/d3ce2d6334d0e6ab/client/wixstores-client/wixstores-client-gallery/src/components/GridGallery/controller.ts';

    
import { createHttpClient } from '@wix/yoshi-flow-editor/runtime/esm/controller/httpClientProp';
    

    
var initI18n = null;

    
const multilingualDisabled = false;

    
import { createExperiments, createWidgetExperiments } from '@wix/yoshi-flow-editor/runtime/esm/experiments';
    

    

    var createErrorMonitor = null;
    

    
var I18nextProvider = React.Fragment;


      import { PureExperimentsProvider } from '@wix/yoshi-flow-editor';
      var ExperimentsProvider = React.Fragment;
      

import { BILoggerProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/BILogger/BILoggerProvider';

import { FedopsLoggerProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/FedopsLoggerProvider';

import { HttpProvider } from '@wix/yoshi-flow-editor';

import { TPAComponentsProvider } from 'wix-ui-tpa';

import { BaseUiEnvironmentProviderWrapper } from '@wix/yoshi-flow-editor/runtime/esm/react/BaseUiEnvironmentProviderWrapper';

var providers = {
  I18nextProvider,
  ExperimentsProvider,
  PureExperimentsProvider,
  BILoggerProvider,
  FedopsLoggerProvider,
  HttpProvider,
  TPAComponentsProvider,
  BaseUiEnvironmentProviderWrapper,
}

    import * as fedopsLogger from '@wix/yoshi-flow-editor/fedops';

    
  import * as viewerApp from '/home/builduser/agent00/work/d3ce2d6334d0e6ab/client/wixstores-client/wixstores-client-gallery/src/viewer.app.ts';
    var importedApp = viewerApp;

    var componentName = 'GridGallery';
    var projectName = 'wixstores-client-gallery';
    var sentryConfig = null;
    import stylesParams from '/home/builduser/agent00/work/d3ce2d6334d0e6ab/client/wixstores-client/wixstores-client-gallery/src/components/GridGallery/stylesParams.ts';
    var experimentsConfig = {"scopes":["viewer-apps-1380b703-ce81-ff05-f115-39571d94dfcd"],"centralized":true};
    var fedopsConfig = null;
    var translationsConfig = {"enabled":false,"icuEnabled":false};
    var defaultTranslations = null;
    var biConfig = null;
    var appDefinitionId = "1380b703-ce81-ff05-f115-39571d94dfcd";
    var componentId = "13afb094-84f9-739f-44fd-78d036adb028";
    var localeDistPath = 'assets/locales';
    var persistentAcrossPages = false;
    var shouldUseEssentials = true;
    var shouldSkipMultipleRendersAfterViewModeChange = false;
    var withErrorBoundary = false;

    import { createVisitorBILogger as biLogger } from '/home/builduser/agent00/work/d3ce2d6334d0e6ab/client/wixstores-client/wixstores-client-gallery/target/generated/bi/createBILogger.ts';
    
      import { hot } from '@wix/component-hot-loader';
      var UserComponent = hot(module, Widget);
    

    var EditorComponent = React.createElement(EditorAppWrapper, {
      UserComponent,
      appDefinitionId,
      componentId,
      name: componentName,
      sentryConfig: sentryConfig,
      experimentsConfig: experimentsConfig,
      fedopsConfig: fedopsConfig,
      multilingualDisabled,
      translationsConfig: translationsConfig,
      defaultTranslations: defaultTranslations,
      shouldUseEssentials,
      persistentAcrossPages,
      projectName: projectName,
      biConfig: biConfig,
      biLogger: biLogger,
      stylesParams,
      withErrorBoundary,
      shouldSkipMultipleRendersAfterViewModeChange,
      userController: createController,
      customInitAppForPage: importedApp.initAppForPage,
      optionalDeps: {
        initI18n,
        fedopsLogger,
        withStylesHoc: withStyles,
        createHttpClient,
        createExperiments,
        createWidgetExperiments,
        createErrorMonitor,
        providers,
      },
      localeDistPath: localeDistPath,
    });
    ReactDOM.render(EditorComponent, document.getElementById('root'));
